﻿import { BaseWidget } from "../BaseWidget";
import { BaseForm } from "./BaseForm";

export class F04_2014 extends BaseForm {

    override updateForm() {
        this.JOINT_PROCUREMENT_INVOLVED_change();
        this.ADDRESS_FURTHER_INFO_change();
        this.URL_TOOL_use_change();
        this.DOCUMENT_change();
    }

    JOINT_PROCUREMENT_INVOLVED_change() {
        this.muVisible((this.ui.JOINT_PROCUREMENT_INVOLVED as HTMLInputElement).checked, "PROCUREMENT_LAW_block");
    }

    ADDRESS_FURTHER_INFO_change() {
        const v = this.muNamedWidget.ADDRESS_FURTHER_INFO.muFetchData() as string;
        this.muVisible(v == "ADDRESS", "ADDRESS_FURTHER_INFO_ADDRESS");
    }

    URL_TOOL_use_change() {
        this.muVisible((this.ui.URL_TOOL_use as HTMLInputElement).checked, "URL_TOOL");
    }

    DOCUMENT_change() {
        const v = this.muNamedWidget.DOCUMENT.muFetchData() as string;
        if (v == "FULL")
            this.muVisible(v == "FULL", "url_restriction");
        else
            this.muVisible(v == "RESTRICTED", "url_restriction");
    }
}

export class F04_2014_PARTICIPATION extends BaseWidget {
    updateForm() {
        this.TYPE_change();
        this.URL_PARTICIPATION_use_change();
    }

    TYPE_change() {
        const v = this.muNamedWidget.TYPE.muFetchData() as string;
        this.muVisible(v == "ADDRESS", "ADDRESS");
        //this.muVisible(v == "URL", "URL_block");
    }

    URL_PARTICIPATION_use_change() {
        this.muVisible((this.ui.URL_PARTICIPATION_use as HTMLInputElement).checked, "URL_PARTICIPATION_block");
    }
}